export default "__VITE_ASSET__BBjKZUPH__"